var styles = {"box":"SimpleLink_box_15d4g_1","icon-container":"SimpleLink_icon-container_15d4g_26","text":"SimpleLink_text_15d4g_48","add-text":"SimpleLink_add-text_15d4g_54","add-node":"SimpleLink_add-node_15d4g_55","active":"SimpleLink_active_15d4g_76","sub-item":"SimpleLink_sub-item_15d4g_80","disable-hover":"SimpleLink_disable-hover_15d4g_87","hovered":"SimpleLink_hovered_15d4g_119"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
